export default __webpack_public_path__ + "static/media/087.7abea2ae.jpg";